import "./App.css";
import Intro from "./components/Intro/Intro";
import { useContext, useEffect } from "react";
import { themeContext } from "./Context";
import { FirebaseContext } from "./components/firebase";
import { doc, getDoc } from 'firebase/firestore'
import { useData } from "./DataContext";
function App() {
  const theme = useContext(themeContext);
  const { database } = useContext(FirebaseContext)
  const { userData, setUserData } = useData()
  const darkMode = theme.state.darkMode;
  useEffect(() => {
    // const unsubscribe = onSnapshot(doc(database, "users", "personaldata"), (doc) => {
    //   console.log("Current data: ", doc.data());
    // });
    // return unsubscribe;
    fetchData()
  }, [])
  const fetchData = async () => {
    const docRef = doc(database, "users", "personaldata");
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      setUserData(docSnap.data())
    } else {
      // doc.data() will be undefined in this case
      console.log("No such document!");
    }
    // const newdocRef1 = doc(database, "users", "personaldata");
    // const newdocRef = await updateDoc(newdocRef1, {
    //   last_name: "Jasoliya",
    // });
  }

  if (Object.keys(userData).length === 0) return null;

  return (
    <div
      className="App"
      style={{
        background: darkMode ? "black" : "",
        color: darkMode ? "white" : "",
        marginTop: -100
      }}
    >
      <Intro />
    </div>
  );
}

export default App;
